const INTERNAL_HOSTS = [
  'test.liunedoor.com',
  'www.liunedoor.com',
  'liunedoor.com',
];
export function localizeHtmlEnglishLinks(html: string, locale?: string) {
  if (!html || locale !== 'en-US') return html;

  return html.replace(/href\s*=\s*(["'])(.*?)\1/gi, (match, quote, href) => {
    const rewritten = rewriteInternalLink(href, locale);
    return rewritten === href ? match : `href=${quote}${rewritten}${quote}`;
  });
}

export function rewriteInternalLink(
  href: string,
  locale?: string,
  baseUrl = 'https://test.liunedoor.com'
): string {
  // Ignore empty or non-English locale
  if (!href || locale !== 'en-US') return href;

  // Ignore anchors, mail, tel
  if (
    href.startsWith('#') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:')
  ) {
    return href;
  }

  try {
    const url = href.startsWith('http')
      ? new URL(href)
      : href.startsWith('//')
      ? new URL(`https:${href}`)
      : new URL(href, baseUrl);

    // Only rewrite INTERNAL links
    if (!INTERNAL_HOSTS.includes(url.hostname)) {
      return href;
    }

    if (url.pathname.startsWith('/en/')) {
      url.pathname = url.pathname.replace(/^\/en\//, '/en-US/');
    }

    // Preserve original format
    return href.startsWith('http') || href.startsWith('//')
      ? url.toString()
      : url.pathname + url.search + url.hash;
  } catch {
    return href;
  }
}
